import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import Bookings from "./Bookings";
import { AuthorizedLayout } from "../Layouts/AuthorizedLayout";
import { Box, Card } from "@mui/material";
import "../../Components/Common/Styles/Formstyles.css";
const BookingsWrapper: React.FC = () => {
  const navigate = useNavigate();
  const { providerId } = useParams<{ providerId: string }>();

  if (!providerId) return null;

  return (
    <AuthorizedLayout>
            <Box sx={{ px: 2, py: 2 }}>
    <Card className="card-layout">
    <Bookings
      providerId={providerId}
      onBack={() => navigate("/providers")}
      onEdit={(tab) => navigate(`/providers/${providerId}/edit?tab=${tab}`)}
    />
  </Card>
    </Box>
    </AuthorizedLayout>
  );
};

export default BookingsWrapper;
